// Fix for Gravity Forms select elements after form validation errors
import { flsModules } from "../../files/modules.js";

// This function will be called when Gravity Forms renders or re-renders a form
function reinitializeSelectsAfterGravityFormsRender() {
  // Check if jQuery and gform are available (Gravity Forms uses jQuery)
  if (typeof jQuery !== "undefined" && typeof gform !== "undefined") {
    // Hook into the gform_post_render event
    jQuery(document).on(
      "gform_post_render",
      function (event, formId, currentPage) {
        // Find all select elements within the form that was just rendered
        const formElement = jQuery("#gform_" + formId);
        if (formElement.length) {
          const selectElements = formElement.find("select");

          // Reinitialize each select element
          if (selectElements.length && flsModules.select) {
            selectElements.each(function () {
              // Check if this select already has the custom styling
              const parentDiv = jQuery(this).parent();
              if (!parentDiv.hasClass("select")) {
                // If not styled yet, initialize it
                flsModules.select.selectInit(this, this.dataset.id || 1);
              }
            });
          }
        }
      }
    );
  }
}

// Initialize when the document is ready
document.addEventListener(
  "DOMContentLoaded",
  reinitializeSelectsAfterGravityFormsRender
);
